import React from "react";

// Simple wrapper to keep illustration usage consistent and academic
export const SideIllustration = ({ src, alt }) => {
  return (
    <div className="relative hidden h-full min-h-[220px] w-full max-w-sm overflow-hidden rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur-xl md:block">
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-cover object-center grayscale-[12%]"
        loading="lazy"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-white/70 via-transparent to-sky-50/40" />
    </div>
  );
};
